import { render, staticRenderFns } from "./KSelect.vue?vue&type=template&id=39f36121&scoped=true&"
import script from "./KSelect.vue?vue&type=script&lang=js&"
export * from "./KSelect.vue?vue&type=script&lang=js&"
import style0 from "./KSelect.vue?vue&type=style&index=0&id=39f36121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f36121",
  null
  
)

export default component.exports